import { render, staticRenderFns } from "./SubstitutesDeputyAuthView.vue?vue&type=template&id=20fac4de&scoped=true&"
import script from "./SubstitutesDeputyAuthView.vue?vue&type=script&lang=js&"
export * from "./SubstitutesDeputyAuthView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fac4de",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VDataTable,VIcon,VRow,VSpacer,VTextField,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20fac4de')) {
      api.createRecord('20fac4de', component.options)
    } else {
      api.reload('20fac4de', component.options)
    }
    module.hot.accept("./SubstitutesDeputyAuthView.vue?vue&type=template&id=20fac4de&scoped=true&", function () {
      api.rerender('20fac4de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/substitutes/SubstitutesDeputyAuthView.vue"
export default component.exports